<template>
  <div class="content">
    <div :class="['number', notmobile ? 'notmobile' : '']">
      <span>+86</span>
      <input type="tel" maxlength="11" v-model="mobile" placeholder="请输入手机号">
    </div>
    <div class="verification-code">
      <div :class="['code', notcode ? 'notcode' : '']">
        <span>验证码</span>
        <input type="code" v-model="code" placeholder="请输入验证码">
      </div>
      <button v-if="!isSend" class="btn" @click="sendCode">{{getCodeMsg}}</button>
      <button v-if="isSend" class="btn send" @click="sendCode">已发送（{{time}}）</button>
    </div>
    <div class="err"></div>
    <button class="login-btn" @click="registerCoach">提交</button>
    <div class="hint">
      <div style="margin-bottom: .2rem">
        <img src="../../assets/images/icon.png" alt="">
        <span>温馨提示</span>
      </div>
      <div style="margin-bottom: .15rem">1.若该手机号尚未注册超级教练APP，系统将自动帮您创建账号</div>
      <div>2.该账号用于接收退还押金，如需提现请下载登录超级教练APP</div>
    </div>
    <div v-if="showDialog" class="dialog-item">
      <dialog-item :value="massage"></dialog-item>
    </div>
  </div>
</template>

<script>
import { registerCoach, sendCode } from '@/http/api'
import dialogItem from '@/components/dialog'
export default {
  data () {
    return {
      mobile: '',
      code: '',
      notmobile: false,
      notcode: false,
      massage: '',
      showDialog: false,
      getCodeMsg: '获取验证码',
      isSend: false,
      time: 0,
      channel_no: ''
    }
  },
  components: {
    'dialog-item': dialogItem
  },
  methods: {
    registerCoach () {
      if (!this.mobile) {
        this.notcode = false
        this.notmobile = true
        this.showDia('请输入手机号')
      } else if (!this.code) {
        this.notmobile = false
        this.notcode = true
        this.showDia('请输入验证码')
      } else {
        let params = {
          mobile: this.mobile,
          code: this.code,
          channel_no: this.channel_no ? this.channel_no : ''
        }
        registerCoach(params).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.notmobile = false
            this.notcode = false
            let registerCoach = res.data
            registerCoach.mobile = this.mobile
            sessionStorage.setItem('registerCoach', JSON.stringify(registerCoach))
            if (this.channel_no) {
              sessionStorage.setItem('other_token', res.data.id)
            }
            this.$router.back(-1)
          } else {
            this.showDia(res.msg)
          }
        })
      }
    },

    showDia (massage) {
      this.showDialog = true
      this.massage = massage
      setTimeout(() => {
        this.showDialog = false
        this.massage = ''
      }, 1500)
    },

    sendCode () {
      if (!this.mobile) {
        this.notcode = false
        this.notmobile = true
        this.showDia('请输入手机号')
      } else {
        let params = {
          mobile: this.mobile
        }
        sendCode(params).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.notmobile = false
            this.isSend = true
            this.time = 60
            let settime = setInterval(() => {
              if (this.time === 0) {
                clearInterval(settime)
                this.isSend = false
                this.getCodeMsg = '重新发送'
              }
              this.time--
            }, 1000)
          } else {
            this.showDia(res.msg)
          }
        })
      }
    },

    signinPact () {
      this.$router.replace({
        path: '/signinPact'
      })
    }
  },
  mounted () {
    this.channel_no = this.$route.query.channel_no
  }
}
</script>

<style lang="scss" scoped>
@mixin input-wrap ($width) {
  width: $width;
  height: .9rem;
  border-radius: .45rem;
  border: 1px solid rgba(239,239,239,1);
  box-sizing: border-box;
  span {
    font-size: .26rem;
    display: inline-block;
    width: 1.4rem;
    text-align: center;
  }

  input {
    font-size: .26rem;
    border: none;
    outline: none;
    width: 2.5rem;
  }
}

.content {
  font-size: 0;
  color: #333;
  width: 100%;
}
.number {
  margin: .5rem auto auto;
  display: flex;
  align-items: center;
  @include input-wrap(6.9rem);
}

.notmobile {
  border: 1px solid #F5232D;
}

.verification-code {
  margin: .3rem auto auto;
  width: 6.9rem;
  overflow: hidden;
  font-size: 0;
  display: flex;
  align-items: center;
  .code {
    display: flex;
    flex: 65;
    align-items: center;
    @include input-wrap(4.5rem);
  }
  .notcode {
    border: 1px solid #F5232D;
  }
  .btn {
    // display: flex;
    text-align: center;
    flex: 35;
    width: 2.2rem;
    margin-left: .2rem;
    height: .9rem;
    line-height: .9rem;
    color: #02B389;
    font-size: .26rem;
    border: 2px solid rgba(2,179,137,1);
    box-sizing: border-box;
    background: none;
    border-radius: .45rem;
    outline: none;
  }
  .send {
    border: 1px solid rgba(51, 51, 51, 0.2);
    color: rgba(51, 51, 51, 0.3);
  }
}
.login-btn {
  width: 6.9rem;
  height: .9rem;
  border-radius: .45rem;
  background: #02B389;
  border: none;
  outline: none;
  display: block;
  margin: .86rem auto auto;
  color: #fff;
  box-shadow:0px 10px 40px rgba(2, 179, 137, .5);
  font-size: .32rem;
}

.protocol {
  width: 6.9rem;
  margin: auto;
  text-align: right;
  font-size: .24rem;
  margin-top: .47rem;
  color: rgba(51, 51, 51, .5);
}

.hint {
  font-size: .24rem;
  padding: 0 .30rem;
  margin-top: 1rem;
  color: rgba(51, 51, 51, 0.5);
  img {
    width: .26rem;
    height: .26rem;
    margin-right: .14rem;
    display: inline-block;
    vertical-align: middle;
  }
  span {
    vertical-align: middle;
    display: inline-block;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/registerCoach/registerCoach.vue